module.exports = __webpack_public_path__ + "static/media/co.f709c74c.svg";